import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Outlet, useLocation, Link } from 'react-router-dom';
import {
  Box,
  Typography,
  CircularProgress,
  Tabs,
  Tab,
} from '@mui/material';
import { useSettingsStore, useAuthStore } from '../../stores/root_store';

export const SettingsPage = observer(() => {
  const settingsStore = useSettingsStore();
  const authStore = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    settingsStore.fetchSettings();
  }, [settingsStore]);

  // Each tab's value is its URL, so the active tab follows the path no
  // matter which role-dependent tabs are shown.
  const tabPaths = [
    '/settings',
    '/settings/edit',
    '/settings/email',
    '/settings/calendar',
    '/settings/appearance',
    '/settings/password',
    ...(authStore.isAssistant ? ['/settings/payouts'] : []),
    ...(authStore.isClient
      ? ['/settings/payments', '/settings/billing', '/settings/credits']
      : []),
  ];
  const tabValue = tabPaths.includes(location.pathname) ? location.pathname : false;

  if (settingsStore.loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      <Tabs value={tabValue} variant="scrollable" scrollButtons="auto" sx={{ mb: 3 }}>
        <Tab label="Overview" value="/settings" component={Link} to="/settings" />
        <Tab label="Edit Profile" value="/settings/edit" component={Link} to="/settings/edit" />
        <Tab label="Email" value="/settings/email" component={Link} to="/settings/email" />
        <Tab label="Calendar" value="/settings/calendar" component={Link} to="/settings/calendar" />
        <Tab label="Appearance" value="/settings/appearance" component={Link} to="/settings/appearance" />
        <Tab label="Password" value="/settings/password" component={Link} to="/settings/password" />
        {authStore.isAssistant && (
          <Tab label="Payouts" value="/settings/payouts" component={Link} to="/settings/payouts" />
        )}
        {authStore.isClient && (
          <Tab label="Payments" value="/settings/payments" component={Link} to="/settings/payments" />
        )}
        {authStore.isClient && (
          <Tab label="Billing" value="/settings/billing" component={Link} to="/settings/billing" />
        )}
        {authStore.isClient && (
          <Tab label="Credits" value="/settings/credits" component={Link} to="/settings/credits" />
        )}
      </Tabs>

      <Outlet />
    </Box>
  );
});
